import { useState } from 'react';

/**
 * Custom hook to manage scene state
 * @param {boolean} showInitialAnimation - Whether to show initial animation
 * @returns {Object} State variables and setters
 */
export const useSceneState = (showInitialAnimation = false) => {
  const [initialized, setInitialized] = useState(false);
  const [animationEnded, setAnimationEnded] = useState(!showInitialAnimation);
  const [modelsLoaded, setModelsLoaded] = useState(true);
  const [environmentPreset, setEnvironmentPreset] = useState("Day");
  const [selectedFloor, setSelectedFloor] = useState(null);
  const [showGrid, setShowGrid] = useState(false);
  const [selectedApartmentNode, setSelectedApartmentNode] = useState();
  const [showEnvironment, setShowEnvironment] = useState(true);
//   const [lastCameraViewData, setLastCameraViewData] = useState();
  const [showPresets, setShowPresets] = useState(true);
  const [selectedModelId, setSelectedModelId] = useState(null);
  const [focusedBuilding, setFocusedBuilding] = useState(null);

  return {
    initialized,
    setInitialized,
    animationEnded,
    setAnimationEnded,
    modelsLoaded,
    setModelsLoaded,
    environmentPreset,
    setEnvironmentPreset,
    selectedFloor,
    setSelectedFloor,
    showGrid,
    setShowGrid,
    selectedApartmentNode,
    setSelectedApartmentNode,
    showEnvironment,
    setShowEnvironment,
    // lastCameraViewData,
    // setLastCameraViewData,
    showPresets,
    setShowPresets,
    selectedModelId,
    setSelectedModelId,
    focusedBuilding,
    setFocusedBuilding,
  };
};
